<template>
  <div class="main">
    <div class="filter">
      <div :class="{ active: dateType == item.status, common: dateType != item.status }"
        v-for="(item, index) in chooseTypes" :key="index" @click="switchStatus(item.status)">
        {{ item.text }}
      </div>
    </div>
    <div class="dataContent">
      <div>招聘数据</div>
      <div class="dataList">
        <div v-for="(item, index) in datatypes" :key="index" @click="switchType(index + 1)">
          <div class="item1">
            <div>{{ item.text }}</div>
            <!-- <div>?</div> -->
          </div>
          <div class="item2">
            <div style="font-size: 20px;">{{ item.newNum }}</div>
            <div class="item3">
              <div>{{ item.compare }}</div>
              <div>{{ item.diff }}</div>
            </div>
          </div>
        </div>
      </div>

      <div ref="chart" style="height: 300px;"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dateType: 0,
      chooseTypes: [{
        text: '日报',
        status: 0
      }, {
        text: '周报',
        status: 1
      }, {
        text: '月报',
        status: 2
      }],
      choice: '1',
      datatypes: [{
        text: '我看过',
        newNum: 0,
        diff: 0,
        compare: '较昨日'
      }, {
        text: '看过我',
        newNum: 0,
        diff: 0,
        compare: '较昨日'
      }, {
        text: '我打招呼',
        newNum: 0,
        diff: 0,
        compare: '较昨日'
      }, {
        text: '牛人打招呼',
        newNum: 0,
        diff: 0,
        compare: '较昨日'
      }],
      myChart: null
    }
  },
  mounted() {
    this.myChart = this.$echarts.init(this.$refs.chart);
    this.getCardList()
    this.getLineData()
  },
  methods: {
    switchType(choice) {
      this.choice = choice + '',
        this.getLineData()
    },
    switchStatus(item) {
      this.dateType = item
      this.datatypes = this.datatypes.map(v => {
        if (item == "0") {
          v.compare = '较昨日'
        } else if (item == "1") {
          v.compare = '近7天'
        } else if (item == "2") {
          v.compare = '近30天'
        }
        return v
      })
      this.getCardList()
      this.getLineData()
    },
    getCardList() {
      this.$get('/api/company/staticData/getCardList', {
        dateType: this.dateType
      }).then(res => {
        this.datatypes = this.datatypes.map((val, key) => {
          res.data.forEach((v, k) => {
            if (k == key) {
              val.diff = v.diff > 0 ? ('+' + v.diff) : v.diff
              val.newNum = v.newNum
            }
          })
          return val
        })
      })
    },
    getLineData() {
      this.$get('/api/company/staticData/getLineData', {
        dateType: this.dateType,
        choice: this.choice
      }).then(res => {
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          xAxis: {
            type: 'category',
            data: res.data.xdata,
          },
          yAxis: {
            type: 'value',
            splitLine: {
              lineStyle: {
                type: 'dashed'//虚线
              },
              // show: true //隐藏
            }
          },
          series: [
            {
              data: res.data.ydata,
              type: 'line',
              smooth: true,
              itemStyle: {
                color: '#0051AA'
              },
              lineStyle: {
                color: '#0051AA'
              },
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(0,81,170,0.2)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        };

        this.myChart.setOption(option);
      })
    }
  }
}
</script>
<style scoped>
.main {
  padding: 30px;
}

.dataContent {
  /* height: 900px; */
  padding: 20px;
  margin-top: 20px;
  background: #FFFFFF;
}

.dataContent>div:nth-of-type(1) {
  width: 72px;
  height: 25px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.dataList {
  margin-top: 30px;
  display: flex;
  justify-content: space-around;
}

.dataList>div {
  width: 230px;
  height: 90px;
  color: #FFFFFF;
  padding: 24px 30px;
  border-radius: 10px;
}

.dataList>div:nth-of-type(1) {
  background: linear-gradient(90deg, rgba(68, 149, 254, 1) 0%, rgba(91, 185, 255, 1) 100%);
}

.dataList>div:nth-of-type(2) {
  background: linear-gradient(90deg, #64C199 0%, #72C87F 100%);
}

.dataList>div:nth-of-type(3) {
  background: linear-gradient(90deg, #426ADE 0%, #6B94F4 100%);
}

.dataList>div:nth-of-type(4) {
  background: linear-gradient(90deg, #EF9741 0%, #EF9741 100%);
}

.item1 {
  display: flex;
}

.item1>div:nth-of-type(1) {
  /* height: 18px; */
  font-size: 18px;
  text-align: center;
  line-height: 18px;
}

.item1>div:nth-of-type(2) {
  margin-left: 10px;
  width: 18px;
  height: 18px;
  font-size: 14px;
  border-radius: 50%;
  text-align: center;
  line-height: 18px;
  border: 1px solid #FFFFFF;
  cursor: pointer;
}

.item2 {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.item3 {
  display: flex;
  align-items: center;
}

.item3>div {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 22px;
  color: #FFFFFF;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.item3>div:nth-of-type(2) {
  margin-left: 10px;
}

.filter {
  display: flex;
}

.filter>div {
  padding: 8px 30px;
  height: 22px;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
}

.common {
  color: #555555;
}

.active {
  background-color: #0051aa;
  color: #ffffff;
}
</style>